<template>
    <div>
        <b-btn v-if="proposal.actions.supplier?.contract === 'sign'" class="btn-card-action btn-card-action-danger my-1" :to="{ name: 'CommercialPurchaseShow', params: { id: proposal.purchase.id }, hash: '#atmo-contract' }" target="_blank">Подписать договор</b-btn>
    </div>
</template>

<script>
export default {
    name: 'cabinet-commercial-proposal-card-contract-button',
    props: {
        proposal: {
            type: Object
        }
    }
};
</script>
